var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenarin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 514.875,
    height: 280.695,
    viewBox: "0 0 514.875 280.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68762",
    "data-name": "Group 68762",
    transform: "translate(-78.368 -47.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34627",
    "data-name": "Group 34627",
    transform: "translate(78.581 295.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26858",
    "data-name": "Path 26858",
    d: "M89.435,186.491h7.189L107.381,216.9h-6.889l-2.007-6.251h-11.2L85.227,216.9H78.581Zm-.418,18.917H96.8l-3.841-11.964Z",
    transform: "translate(-78.581 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26859",
    "data-name": "Path 26859",
    d: "M97.205,200.051h6.251v6.169H97.205Z",
    transform: "translate(-63.915 -174.883)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26860",
    "data-name": "Path 26860",
    d: "M131.35,186.491h9.143V216.9h-5.92V196.331q0-.888.02-2.486t.021-2.465L128.851,216.9h-6.174l-5.722-25.518q0,.869.021,2.465t.02,2.486V216.9h-5.92V186.491h9.245l5.536,23.908Z",
    transform: "translate(-52.991 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26861",
    "data-name": "Path 26861",
    d: "M153.388,191.875H137.3v6.456h14.77v5.282H137.3v7.818H154.13V216.9H131.089V186.491h22.3Z",
    transform: "translate(-37.231 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26862",
    "data-name": "Path 26862",
    d: "M146.76,186.491h6.66l12.071,21.2v-21.2h5.92V216.9h-6.353L152.68,195.323V216.9h-5.92Z",
    transform: "translate(-24.89 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26863",
    "data-name": "Path 26863",
    d: "M173.58,186.491h7.189L191.526,216.9h-6.889l-2.007-6.251h-11.2l-2.061,6.251h-6.646Zm-.418,18.917h7.786l-3.841-11.964Z",
    transform: "translate(-12.317 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26864",
    "data-name": "Path 26864",
    d: "M200.411,187.276a7.491,7.491,0,0,1,2.846,2.125,9.414,9.414,0,0,1,1.528,2.558,8.521,8.521,0,0,1,.563,3.2,9.123,9.123,0,0,1-1.092,4.26,6.109,6.109,0,0,1-3.611,2.96,5.689,5.689,0,0,1,2.982,2.4,10.043,10.043,0,0,1,.876,4.757v2.041a15.31,15.31,0,0,0,.168,2.828,2.548,2.548,0,0,0,1.173,1.732v.763H198.83c-.193-.674-.331-1.219-.413-1.63a14.752,14.752,0,0,1-.268-2.621l-.041-2.826q-.04-2.907-1.006-3.879t-3.62-.969h-6.2V216.9h-6.21V186.491h14.545A13.225,13.225,0,0,1,200.411,187.276Zm-13.133,4.5v8.169h6.837a7.265,7.265,0,0,0,3.057-.5,3.419,3.419,0,0,0,1.8-3.423q0-2.764-1.743-3.713a6.272,6.272,0,0,0-2.939-.538Z",
    transform: "translate(2.128 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26865",
    "data-name": "Path 26865",
    d: "M204.172,216.9H197.86V186.491h6.312Z",
    transform: "translate(15.352 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26866",
    "data-name": "Path 26866",
    d: "M204.879,186.491h6.66l12.071,21.2v-21.2h5.92V216.9h-6.353L210.8,195.323V216.9h-5.92Z",
    transform: "translate(20.879 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26867",
    "data-name": "Path 26867",
    d: "M228.369,216.9h-6.312V186.491h6.312Z",
    transform: "translate(34.407 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26868",
    "data-name": "Path 26868",
    d: "M256.3,203.737q-2.671,2.228-7.626,2.227h-6.331V216.9h-6.312V186.491h13.054a10.539,10.539,0,0,1,7.2,2.352q2.684,2.351,2.685,7.28Q258.971,201.511,256.3,203.737Zm-4.848-10.954a5.125,5.125,0,0,0-3.382-1.012h-5.727v8.954h5.727a4.87,4.87,0,0,0,3.382-1.092,4.47,4.47,0,0,0,1.2-3.466A4.2,4.2,0,0,0,251.453,192.783Z",
    transform: "translate(45.412 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26869",
    "data-name": "Path 26869",
    d: "M275.567,214.605q-3.445,3.55-9.964,3.546t-9.963-3.546q-4.62-4.352-4.621-12.543,0-8.352,4.621-12.543,3.445-3.545,9.963-3.548t9.964,3.548q4.6,4.191,4.6,12.543Q280.166,210.253,275.567,214.605Zm-3.972-4.622q2.217-2.78,2.218-7.92,0-5.113-2.218-7.91a7.243,7.243,0,0,0-5.992-2.8,7.342,7.342,0,0,0-6.022,2.783q-2.252,2.788-2.25,7.922t2.25,7.92a7.335,7.335,0,0,0,6.022,2.787A7.251,7.251,0,0,0,271.595,209.983Z",
    transform: "translate(57.215 -185.971)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26870",
    "data-name": "Path 26870",
    d: "M289.58,187.276a7.483,7.483,0,0,1,2.848,2.125,9.415,9.415,0,0,1,1.528,2.558,8.522,8.522,0,0,1,.563,3.2,9.122,9.122,0,0,1-1.092,4.26,6.114,6.114,0,0,1-3.611,2.96,5.691,5.691,0,0,1,2.98,2.4,10.018,10.018,0,0,1,.878,4.757v2.041a15.324,15.324,0,0,0,.168,2.828,2.543,2.543,0,0,0,1.173,1.732v.763H288c-.193-.674-.331-1.219-.413-1.63a14.918,14.918,0,0,1-.266-2.621l-.041-2.826q-.04-2.907-1.006-3.879t-3.62-.969h-6.206V216.9h-6.208V186.491h14.543A13.209,13.209,0,0,1,289.58,187.276Zm-13.133,4.5v8.169h6.839a7.266,7.266,0,0,0,3.057-.5,3.419,3.419,0,0,0,1.8-3.423q0-2.764-1.743-3.713a6.277,6.277,0,0,0-2.939-.538Z",
    transform: "translate(72.35 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26871",
    "data-name": "Path 26871",
    d: "M310.435,186.491v5.384h-9.1V216.9h-6.4V191.875H285.8v-5.384Z",
    transform: "translate(84.609 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26872",
    "data-name": "Path 26872",
    d: "M301.737,186.491h6.456v18.674a10.567,10.567,0,0,0,.74,4.576q1.15,2.558,5.016,2.556,3.845,0,4.994-2.556a10.57,10.57,0,0,0,.74-4.576V186.491h6.458v18.69a15.691,15.691,0,0,1-1.505,7.55q-2.8,4.95-10.687,4.95t-10.709-4.95a15.672,15.672,0,0,1-1.5-7.55Z",
    transform: "translate(97.155 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26873",
    "data-name": "Path 26873",
    d: "M339.97,196.326a5.955,5.955,0,0,0-3.528-4.353,8.632,8.632,0,0,0-3.486-.681,7.578,7.578,0,0,0-6.035,2.769q-2.36,2.77-2.361,8.328,0,5.6,2.558,7.928a8.413,8.413,0,0,0,5.817,2.326,7.548,7.548,0,0,0,5.241-1.834A7.921,7.921,0,0,0,340.693,206h-7.036v-5.075h12.666v16.318h-4.208l-.64-3.8a14.575,14.575,0,0,1-3.3,3.041,11.662,11.662,0,0,1-6.19,1.539,12.86,12.86,0,0,1-9.9-4.185q-4.022-4.207-4.024-11.5,0-7.379,4.065-11.831a13.854,13.854,0,0,1,10.748-4.453q5.794,0,9.313,2.939a10.935,10.935,0,0,1,4.033,7.334Z",
    transform: "translate(110.01 -185.906)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26874",
    "data-name": "Path 26874",
    d: "M346.926,186.491h7.188L364.871,216.9h-6.889l-2.007-6.251h-11.2l-2.061,6.251h-6.646Zm-.42,18.917h7.786l-3.841-11.964Z",
    transform: "translate(124.193 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26875",
    "data-name": "Path 26875",
    d: "M354.371,186.491h6.353v24.941h15.183V216.9H354.371Z",
    transform: "translate(138.605 -185.561)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26876",
    "data-name": "Path 26876",
    d: "M276.59,47.949",
    transform: "translate(155.933 0.727)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 2.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26877",
    "data-name": "Path 26877",
    d: "M361.8,47.556,265.086,180.47l-96.7-132.914H361.8",
    transform: "translate(70.725 0.417)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26878",
    "data-name": "Path 26878",
    d: "M229.324,106.785l-10.605-2.672V99.662H232.2v2.876h-9.113c-.27,0-.631,0-1.1-.005s-.838-.011-1.092-.011l11.306,2.8v3.016l-11.306,2.774c.254,0,.622,0,1.092-.005s.831-.007,1.1-.007H232.2v2.881H218.719v-4.5l10.605-2.692",
    transform: "translate(110.359 41.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26879",
    "data-name": "Path 26879",
    d: "M229.324,106.785l-10.605-2.672V99.662H232.2v2.876h-9.113c-.27,0-.631,0-1.1-.005s-.838-.011-1.092-.011l11.306,2.8v3.016l-11.306,2.774c.254,0,.622,0,1.092-.005s.831-.007,1.1-.007H232.2v2.881H218.719v-4.5Z",
    transform: "translate(110.359 41.451)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26880",
    "data-name": "Path 26880",
    d: "M218.719,92.091h2.387v7.836h2.868V92.732h2.342v7.195h3.462v-8.2H232.2v11.229H218.719V92.091",
    transform: "translate(110.36 35.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26881",
    "data-name": "Path 26881",
    d: "M218.719,92.091h2.387v7.836h2.868V92.732h2.342v7.195h3.462v-8.2H232.2v11.229H218.719Z",
    transform: "translate(110.36 35.199)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26882",
    "data-name": "Path 26882",
    d: "M232.2,95.7H218.719V92.46l9.414-5.9h-9.414V83.677H232.2v3.092l-9.574,6.051H232.2V95.7",
    transform: "translate(110.36 28.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26883",
    "data-name": "Path 26883",
    d: "M232.2,95.7H218.719V92.46l9.414-5.9h-9.414V83.677H232.2v3.092l-9.574,6.051H232.2Z",
    transform: "translate(110.36 28.863)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26884",
    "data-name": "Path 26884",
    d: "M227.111,79.978v3.756L221.8,81.828l5.307-1.85M232.2,85.6l-2.767-1.028V79.118l2.767-.962V74.8l-13.481,5.246v3.5L232.2,88.829Z",
    transform: "translate(110.359 21.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26885",
    "data-name": "Path 26885",
    d: "M232.2,85.6l-2.767-1.028V79.118l2.767-.961V74.8l-13.481,5.248v3.5L232.2,88.83Z",
    transform: "translate(110.36 21.873)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26886",
    "data-name": "Path 26886",
    d: "M225.753,77.7v3.755l-5.308-1.9Z",
    transform: "translate(111.718 24.153)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26887",
    "data-name": "Path 26887",
    d: "M221.3,71.026a1.64,1.64,0,0,1,1.645-.89,1.472,1.472,0,0,1,1.516.928,4.286,4.286,0,0,1,.223,1.561v3.509h-3.621v-3.6a3.7,3.7,0,0,1,.238-1.509m-2.585,8.131H232.2V76.133h-5.289V72.942a2.982,2.982,0,0,1,.434-1.866,2.281,2.281,0,0,1,1.72-.515l1.251-.025a6.215,6.215,0,0,0,1.171-.129c.175-.039.413-.105.713-.2V66.8h-.331a1.125,1.125,0,0,1-.769.561,5.635,5.635,0,0,1-1.258.088h-.906a4.189,4.189,0,0,0-2.113.42,2.786,2.786,0,0,0-1.06,1.451,2.911,2.911,0,0,0-1.309-1.754,3.779,3.779,0,0,0-1.893-.534,3.494,3.494,0,0,0-1.414.277,4.253,4.253,0,0,0-1.132.761,3.825,3.825,0,0,0-.947,1.425,7.517,7.517,0,0,0-.35,2.4Z",
    transform: "translate(110.359 15.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26888",
    "data-name": "Path 26888",
    d: "M218.719,79.157H232.2V76.133h-5.289V72.942a2.982,2.982,0,0,1,.434-1.866,2.281,2.281,0,0,1,1.72-.515l1.251-.025a6.215,6.215,0,0,0,1.171-.129c.175-.039.413-.105.713-.2V66.8h-.331a1.125,1.125,0,0,1-.769.561,5.635,5.635,0,0,1-1.258.088h-.906a4.189,4.189,0,0,0-2.113.42,2.786,2.786,0,0,0-1.06,1.451,2.911,2.911,0,0,0-1.309-1.754,3.779,3.779,0,0,0-1.893-.534,3.494,3.494,0,0,0-1.414.277,4.253,4.253,0,0,0-1.132.761,3.825,3.825,0,0,0-.947,1.425,7.517,7.517,0,0,0-.35,2.4Z",
    transform: "translate(110.359 15.572)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26889",
    "data-name": "Path 26889",
    d: "M220.27,69.556a1.64,1.64,0,0,1,1.645-.89,1.472,1.472,0,0,1,1.516.928,4.289,4.289,0,0,1,.223,1.56v3.509h-3.621v-3.6A3.7,3.7,0,0,1,220.27,69.556Z",
    transform: "translate(111.393 17.042)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15778",
    "data-name": "Rectangle 15778",
    width: 13.48,
    height: 3.08,
    transform: "translate(329.079 77.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15779",
    "data-name": "Rectangle 15779",
    width: 13.48,
    height: 3.08,
    transform: "translate(329.079 77.11)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26890",
    "data-name": "Path 26890",
    d: "M232.2,67.567H218.719V64.321l9.414-5.9h-9.414V55.543H232.2v3.092l-9.574,6.049H232.2v2.883",
    transform: "translate(110.36 6.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26891",
    "data-name": "Path 26891",
    d: "M232.2,67.567H218.719V64.321l9.414-5.9h-9.414V55.543H232.2v3.092l-9.574,6.049H232.2Z",
    transform: "translate(110.36 6.707)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15780",
    "data-name": "Rectangle 15780",
    width: 13.48,
    height: 3.075,
    transform: "translate(329.079 56.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15781",
    "data-name": "Rectangle 15781",
    width: 13.48,
    height: 3.075,
    transform: "translate(329.079 56.534)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26892",
    "data-name": "Path 26892",
    d: "M188.644,194.8V107.088l60.493,86.488,60.49-86.488V194.8H188.644",
    transform: "translate(86.675 47.299)",
    fill: "#cd2e26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26893",
    "data-name": "Path 26893",
    d: "M249.865,198.768l-.007-.009H187.719v-94.6L249.865,193l62.143-88.85v94.6l-62.143.009Zm2.315-3.314H308.7V114.639L252.18,195.454Zm-61.156,0h56.524l-56.524-80.815v80.815Z",
    transform: "translate(85.947 44.989)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 24.424,
    transform: "translate(337.899 241.41)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 0.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 24.424,
    transform: "translate(337.899 243.581)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 0.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26894",
    "data-name": "Path 26894",
    d: "M364.178,243.743H167.467V47.026H364.178V243.743Zm-193.408-3.3h190.1V50.329H170.77v190.11Z",
    transform: "translate(69.998 0)",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenarin);
export default __webpack_public_path__ + "static/media/menarin.bc6209b9e14b9d5b6481d3b6f7449f92.svg";
export { ForwardRef as ReactComponent };